import {
  HomeYoutubeHeader,
  HomeYoutubeVideoItem,
  HomeYoutubeVideoItemContentChannel,
  HomeYoutubeVideoItemContentWrapper,
  HomeYoutubeVideoItemThumbnail,
  HomeYoutubeVideoRow,
  HomeYoutubeVideoWrapper,
  HomeYoutubeWrapper,
  SkeletonBox,
  SkeletonChannelAvatar,
  SkeletonText,
  SkeletonThumbnail,
} from "./styles";

const YoutubeSkeleton = () => {
  return (
    <HomeYoutubeWrapper>
      <HomeYoutubeVideoWrapper>
        <HomeYoutubeHeader>
          홀덤 관련 <span>인기 영상</span>
        </HomeYoutubeHeader>
        <HomeYoutubeVideoRow>
          {Array.from({ length: 3 }).map((_, index) => (
            <HomeYoutubeVideoItem key={index} index={index}>
              <HomeYoutubeVideoItemThumbnail>
                <SkeletonThumbnail />
              </HomeYoutubeVideoItemThumbnail>
              <HomeYoutubeVideoItemContentWrapper>
                <SkeletonText width="100%" height="100px" />
                <HomeYoutubeVideoItemContentChannel>
                  <SkeletonChannelAvatar />
                  <SkeletonText width="60px" height="14px" />
                </HomeYoutubeVideoItemContentChannel>
              </HomeYoutubeVideoItemContentWrapper>
            </HomeYoutubeVideoItem>
          ))}
        </HomeYoutubeVideoRow>
      </HomeYoutubeVideoWrapper>

      {/* 채널 스켈레톤 */}
      <SkeletonBox height="70px" marginTop="20px" />
    </HomeYoutubeWrapper>
  );
};

export default YoutubeSkeleton;
